import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  ImageListItem,
  Stack,
  Grid,
} from "@mui/material";
import iphoneOne from "./assets/iphone/iphone_1.png";
import iphoneFour from "./assets/iphone/iphone_2.png";
import iphoneFive from "./assets/iphone/iphone_3.png";
import iphoneSix from "./assets/iphone/iphone_4.png";
import iphoneSeven from "./assets/iphone/iphone_5.png";
import iphoneEight from "./assets/iphone/iphone_6.png";
import iphoneNine from "./assets/iphone/iphone_7.png";
import iphoneTen from "./assets/iphone/iphone_8.png";

import webDevSeven from "./assets/web-dev/web_dev_7.png";
import portalNine from "./assets/portal/portal_8.png";

import { Divider } from "@mui/material";
import { useLocation } from "react-router-dom";

import {
  ChevronLeft,
  ChevronRight,
  FiberManualRecord,
} from "@mui/icons-material";
import Footer from "./footer";

const IOSDevelopment = () => {
  const scrollRef = useRef();
  const { pathname } = useLocation();

  const images = [iphoneNine, iphoneFour, iphoneFive, iphoneSix, iphoneTen];

  const indexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    const width = scrollRef.current.offsetWidth;
    scrollRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleManualScroll = (direction) => {
    const newIndex =
      (indexRef.current + direction + images.length) % images.length;
    indexRef.current = newIndex;
    scrollToIndex(newIndex);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % images.length;
      scrollToIndex(indexRef.current);
    }, 3000); // every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${iphoneOne})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(2px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box sx={{ maxWidth: "auto", mb: 4, zIndex: 2 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              iOS Development
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
          <Box
            sx={{
              pl: { xs: 2, md: 0 },
              pr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              iOS Development
            </Typography>
            <Typography variant="body1" paragraph>
              Native iOS development enables businesses to create powerful,
              high-performance applications specifically designed for Apple’s
              ecosystem, including iPhone, iPad, and Apple Watch. By using
              technologies like Swift and Objective-C, we ensure that your app
              integrates seamlessly with Apple hardware and software, providing
              a smooth, responsive, and intuitive user experience. Native
              development allows full access to iOS features such as Face ID,
              CoreML, ARKit, and advanced haptics—helping your app stand out in
              both functionality and design.
            </Typography>

            <Typography variant="body1" paragraph>
              Our team is experienced in building applications that extend
              beyond phones and tablets. We also create Apple Watch apps that
              support health tracking, notifications, quick actions, and
              more—perfect for users on the go. Whether you're launching a new
              product or enhancing an existing one, we craft reliable, scalable
              iOS applications that align with your business goals and deliver
              long-term value.
            </Typography>
          </Box>
        </Grid>

        <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
          <Box
            flex={1}
            maxHeight="800px"
            overflow="auto"
            borderLeft="1px solid #ccc"
            sx={{ pl: { xs: 0, md: 2 } }}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "100%",
                  mx: "auto",
                  overflow: "hidden",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <IconButton onClick={() => handleManualScroll(-1)}>
                  <ChevronLeft />
                </IconButton>

                <Box
                  ref={scrollRef}
                  sx={{
                    width: { xs: "100%", md: 600 },
                    height: { xs: "100%", md: 500 },
                    display: "flex",
                    overflowX: "hidden",
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {images.map((src, index) => (
                    <ImageListItem
                      key={index}
                      sx={{
                        flex: "0 0 100%",
                        scrollSnapAlign: "center",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px", // Adjust as needed (e.g., 8px, 24px)
                        }}
                        loading="lazy"
                      />
                    </ImageListItem>
                  ))}
                </Box>

                <IconButton onClick={() => handleManualScroll(1)}>
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Indicators */}
              <Stack
                direction="row"
                justifyContent="center"
                mt={2}
                sx={{ mt: 5 }}
              >
                {images.map((_, index) => (
                  <IconButton
                    key={index}
                    size="small"
                    onClick={() => scrollToIndex(index)}
                  >
                    <FiberManualRecord
                      fontSize="small"
                      color={index === activeIndex ? "primary" : "disabled"}
                    />
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "orange", mt: 5 }} />

      <Box sx={{ width: { xs: "100%", md: "80%" }, mx: "auto", mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            px: 2,
            mt: 5,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ color: "orange", fontWeight: "bold", mb: 1 }}
            >
              Why us?
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              Choosing the right team to develop your iOS application is crucial
              for your business success. At our company, we bring unmatched
              expertise in both mobile development and strategic project
              execution. Our deep understanding of Apple’s development
              ecosystem, including its guidelines, design principles, and
              performance expectations, allows us to build applications that not
              only function seamlessly but also deliver exceptional user
              experiences. From startups to large enterprises, we’ve helped
              diverse clients achieve their digital goals efficiently. Our
              dedicated team ensures that every iOS project we undertake is
              carefully crafted, performance-optimized, and future-ready. We
              believe in transparent communication, agile processes, and
              building long-term partnerships. With a customer-centric approach,
              we work closely with you to understand your unique needs and
              business objectives. This helps us create tailored iOS
              applications that stand out in the competitive App Store and
              support the growth of your business.
            </Typography>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        {/* Content Block: Image Left, Text Right */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={portalNine}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Years of experience
            </Typography>
            <Typography variant="body1">
              With several years of hands-on experience in mobile app
              development, our team has built a solid reputation for delivering
              scalable and high-performing iOS applications. Over time, we’ve
              developed expertise in various industries including healthcare,
              e-commerce, education, and finance. This breadth of experience
              allows us to anticipate challenges and offer innovative solutions
              that align with your business needs. Our seasoned developers are
              adept at implementing best practices and using efficient
              development methodologies. We understand the importance of
              reliability, security, and usability in iOS apps and incorporate
              these elements throughout the development lifecycle. Our
              commitment to quality and consistency ensures that each app we
              create contributes positively to the client’s digital
              transformation journey.
            </Typography>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Latest tools and technologies
            </Typography>
            <Typography variant="body1">
              Staying ahead in the tech landscape is essential, and we
              continuously update our toolset to include the most advanced and
              effective technologies. From Swift and SwiftUI to Xcode’s latest
              features and integrations with Apple’s ecosystem, we leverage
              modern tools to build high-performance apps. Our developers also
              make use of robust testing frameworks, analytics tools, and cloud
              services to enhance functionality and maintain high standards. By
              incorporating the latest technologies, we ensure that your iOS app
              is not only future-proof but also delivers top-tier functionality
              and user engagement. Whether it's integrating machine learning,
              enabling push notifications, or supporting Apple Watch and other
              devices, we deliver solutions that are both innovative and
              user-friendly.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={iphoneSeven}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            pb: { xs: 2, md: 0 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={iphoneEight}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Affordable iOS Application development
            </Typography>
            <Typography variant="body1">
              We understand that budget is a key consideration for any business.
              That’s why we offer affordable iOS development solutions without
              compromising on quality or performance. Our pricing models are
              flexible, transparent, and designed to suit a range of business
              sizes and needs. Whether you’re a startup looking to launch your
              first app or a large company seeking custom features, we provide
              value-driven services that meet your budget. Our goal is to make
              premium iOS app development accessible. We optimize resource
              allocation, reduce unnecessary costs, and streamline development
              to provide timely delivery and measurable results. You get a
              high-quality, fully functional iOS application that aligns with
              your business objectives — all within your financial plan.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Extended Support
            </Typography>
            <Typography variant="body1">
              Our relationship with clients doesn’t end after app deployment. We
              provide extended support to ensure your iOS application continues
              to perform optimally. From monitoring usage and analytics to
              handling updates, bug fixes, and enhancements, our support team is
              readily available to assist whenever you need help. We understand
              that user expectations and technology standards evolve rapidly.
              Our ongoing support ensures that your app stays up-to-date with
              the latest iOS versions and device compatibility. Whether it's
              maintaining security, adding new features, or scaling to meet
              growing demand, we’re here to keep your application running
              smoothly and successfully.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={webDevSeven}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default IOSDevelopment;
